// extracted by mini-css-extract-plugin
export default {"jl_image":"image_jl_image__njVIR","jl_image_sans_lien":"image_jl_image_sans_lien__VbD65"};